module.exports = __webpack_public_path__ + "img/6.94cf17ea.jpg";